export type SocialPlatform =
    | "facebook"
    | "instagram"
    | "pinterest"
    | "behance"
    | "website";

export type SocialLinks = Record<SocialPlatform, string>;

export const socialIcons: Record<SocialPlatform, string> = {
    facebook: 'ph:facebook-logo',
    instagram: 'ph:instagram-logo',
    pinterest: 'ph:pinterest-logo',
    behance: 'ph:behance-logo',
    website: 'ph:globe',
};
